export const GET_SETTING = 'GET_SETTING';
export const GET_SETTING_SUCCESS = 'GET_SETTING_SUCCESS';
export const GET_SETTING_FAILED = 'GET_SETTING_FAILED';
